import BackOfficeRole from "./role/BackOfficeRole.js";
import User from "./User.js";

/**
 * `BackOfficeUser` is a user model used mainly to redirect the user
 * to the correct page after login.
 */
export default class BackOfficeUser extends User {
	isBackOfficeUser() {
		return true;
	}

	hasCompanyRole() {
		return true;
	}

	canForcePackageSelection() {
		return true;
	}

	canBeNotifiedFor() {
		return true;
	}

	canSendPeriodNotifications() {
		return true;
	}

	getRoles() {
		// TODO: This method and its class will be deleted by
		// FTGP-5715
		return [new BackOfficeRole()];
	}

	getCompanyIds() {
		return [];
	}

	canUpgradeCompany() {
		return true;
	}

	canDowngradeCompany() {
		return true;
	}

	canEditLiquidityReport() {
		return true;
	}

	canViewWithdrawnPeriodReports() {
		return true;
	}

	canSeePeriodReportViewers() {
		return !this.isTemporaryUser();
	}

	canGoToCountry() {
		return true;
	}

	removeCompany() {
		// nothing to do as the backoffice user is not attached to any company
	}

	_defaultTypeOfUser() {
		return "BackOffice";
	}

	static possibleTypes() {
		return ["BackOffice"];
	}
}
